//#region src/mod_group_display_style.ts
var ModGroupDisplayStyle = /* @__PURE__ */ function(ModGroupDisplayStyle) {
	ModGroupDisplayStyle["Carousel"] = "carousel";
	ModGroupDisplayStyle["Default"] = "default";
	ModGroupDisplayStyle["LargeImage"] = "large-image";
	ModGroupDisplayStyle["Quantity"] = "quantity";
	ModGroupDisplayStyle["RowSizeGroup"] = "row-size-group";
	ModGroupDisplayStyle["SizeGroup"] = "size-group";
	ModGroupDisplayStyle["Slider"] = "slider";
	return ModGroupDisplayStyle;
}(ModGroupDisplayStyle || {});
//#endregion
export { ModGroupDisplayStyle };

//# sourceMappingURL=mod_group_display_style.js.map